// import * as elementPackage from "element-ui/package.json";
import { ELEMENT_ORIGINAL_THEME } from "./index";
import axios from "axios";

let element = {
    css: ''
};
async function getElementCss() {
    if (!element.css) {
        const url = process.env.BASE_URL + 'element-ui.css';
        const response = await axios.get(url)
        
        element.css = response.data.replace(/@font-face{[^}]+}/, '');
    }
    return element.css;
}

export async function updateElementTheme(theme: string) {
    const css = await getElementCss();
    const themeCluster = getThemeCluster(theme.replace('#', ''));

    getHandler(css, 'element-chalk-style', { themeCluster, ORIGINAL_THEME: ELEMENT_ORIGINAL_THEME })
    document.body.style.setProperty('--color-primary', theme);
}


const getHandler = (css, id, { ORIGINAL_THEME, themeCluster }) => {
    const originalCluster = getThemeCluster(ORIGINAL_THEME.replace('#', ''))
    const newStyle = updateStyle(css, originalCluster, themeCluster)

    let styleTag = document.getElementById(id)
    if (!styleTag) {
        styleTag = document.createElement('style')
        styleTag.setAttribute('id', id)
        document.head.appendChild(styleTag)
    }
    styleTag.innerText = newStyle
}

function getThemeCluster(theme: string) {
    const tintColor = (color: string, tint: number) => {
        let red: string | number = parseInt(color.slice(0, 2), 16)
        let green: string | number = parseInt(color.slice(2, 4), 16)
        let blue: string | number = parseInt(color.slice(4, 6), 16)

        if (tint === 0) { // when primary color is in its rgb space
            return [red, green, blue].join(',')
        } else {
            red += Math.round(tint * (255 - red))
            green += Math.round(tint * (255 - green))
            blue += Math.round(tint * (255 - blue))

            red = red.toString(16)
            green = green.toString(16)
            blue = blue.toString(16)

            return `#${red}${green}${blue}`
        }
    }

    const shadeColor = (color: string, shade: number) => {
        let red: string | number = parseInt(color.slice(0, 2), 16)
        let green: string | number = parseInt(color.slice(2, 4), 16)
        let blue: string | number = parseInt(color.slice(4, 6), 16)

        red = Math.round((1 - shade) * red)
        green = Math.round((1 - shade) * green)
        blue = Math.round((1 - shade) * blue)

        red = red.toString(16)
        green = green.toString(16)
        blue = blue.toString(16)

        return `#${red}${green}${blue}`
    }

    const clusters = [theme]
    for (let i = 0; i <= 9; i++) {
        clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
    }
    clusters.push(shadeColor(theme, 0.1))
    return clusters
}

function updateStyle(style:string, oldCluster: string[], newCluster:string[]) {
    let newStyle = style
    oldCluster.forEach((color, index) => {
        newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
    })
    return newStyle
}

